import React, { useCallback, useState, useRef, useEffect  } from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, Fab, Grid, CircularProgress  } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import CloseIcon from '@mui/icons-material/Close';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Webcam from "react-webcam";

const ScanCam = (props) => {
  const webcamRef = useRef(null);
  const [ isCamFront, setIsCamFront] = useState(false);
  const [ videoConstraints, setVideoConstraints] = useState({
    facingMode: { exact: "environment" }
  });

  useEffect(() => {
  }, [props.isOpen]);

  const capture = useCallback(() => {
    const _imgB64 = webcamRef.current.getScreenshot({width: 800, height: 1040});//{width: 1920, height: 1080}
    if(props.onCamCapture) props.onCamCapture(_imgB64);
  }, [webcamRef]);

  const onClose = () =>{
    if(props.onClose) props.onClose();
  };
  const camSideChange = () => {
    setIsCamFront(!isCamFront);
    setTimeout(() => {
      var _constraints = {...videoConstraints};
      _constraints.facingMode = isCamFront ? { exact: "environment" } : 'user';
      setVideoConstraints(_constraints);
    }, 0.2*1000);
  };

  return (
    <Dialog open={props.isOpen} fullWidth maxWidth="xs" sx={{minHeight:'500px'}}>
      <DialogTitle>Scan</DialogTitle>
      <DialogContent>
        <Box>
          <Box>
            <Fab onClick={camSideChange} color="secondary" aria-label="add">
              <SyncIcon />
            </Fab>
          </Box>
          <Webcam
            width={210} height={297}
            ref={webcamRef}
            videoConstraints={videoConstraints}
            audio={false}
            screenshotFormat="image/jpeg"
            forceScreenshotSourceSize
          ></Webcam>
          <Box>
            <Fab onClick={capture} color="primary" aria-label="add">
              <CameraAltIcon />
            </Fab>
          </Box>
        </Box>
      </DialogContent>
      <Button onClick={onClose} style={{ position: 'absolute', top: 0, right: 0 }}>
        <CloseIcon />
      </Button>
    </Dialog>
  );
};

export default ScanCam;
